import Browserizr from 'browserizr';

document.querySelector('body').classList.add(Browserizr.detect().cssClasses(['Mobile'], 'browser-'));
